<!--
  画面名：-
  概要： 食材に含まれるアレルゲンのコンポーネント
  備考： -
-->

<!-- HTML -->
<template>
  <section style="margin-top: 10px !important;padding-bottom: 5%;" class="allergenArea">
    <!-- タイトル -->
    <h3 style="padding-bottom: 4px;">{{$language.LabelIntoFoodAllergen}}</h3>
    <!-- 食材に含まれるアレルゲンを表示 -->
    <table :class="{disabledArea:refer}" @click="allergenAlert(isCooking)">
      <tbody>
        <tr
          v-for="(element,index) in allergens"
          :key="index"
        >
          <th v-if="element.head" :rowspan="element.rowspan">{{element.head}}</th>
          <td
            v-for="(name, index) in element.td"
            :key="index"
          >
            <!-- アレルゲンのチェックボックス -->
            <v-checkbox v-model="allergenChecks" :value="name.id" :label="name.allergen" :input-value="name.inputValue"></v-checkbox>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
</template>
<!-- /HTML -->

<script>

export default {
  // 親コンポーネントから値を受け取る
  props: {
    // チェックされたアレルゲンを格納
    allergenchecked: { type: String, default: '' },
    // レシピページかどうか判定
    isCooking: { type: Boolean, default: false },
    // 参照モーダル判定
    isRefer: { type: Boolean, default: false }
  },
  // 初期値設定
  data () {
    return {
      // アレルゲンのリスト
      allergens: [],
      // チェックされたアレルゲンを格納
      allergenChecks: [],
      refer: false
    }
  },
  created () {
    if (this.isCooking || this.isRefer) {
      this.refer = true
    }
  },
  watch: {
    isCooking () {
      if (this.isCooking || this.isRefer) {
        this.refer = true
      } else {
        this.refer = false
      }
    }
  },
  // コンポーネントの処理を記載
  methods: {
    // アレルゲンのリストボックスをクリックした時に発火する処理
    allergenAlert () {
      if (this.isCooking) {
        // 食材を登録しないとアレルゲンは追加出来ない旨のメッセージをダイアログで表示
        this.$emit('allergenAlert')
      }
    },
    // DBからアレルゲンのjsonデータを取得。親要素から発火される。
    makeAllergenFrame () {
      let self = this
      // コールバック関数を呼び出す
      function callbackGet (value) {
        // データベースから取得したアレルゲン一覧を格納
        self.allergens = value
        self.setAllergen()
        self.$forceUpdate()
        // プログレスバーの非表示
        self.$store.dispatch('setIsLoading', false)
        self.$emit('send')
      }
      self.callback = callbackGet
      // アレルゲン一覧の取得
      this.$store.dispatch('allergen/actionSelectAllergen', self)
    },
    // アレルゲンのチェックをセットする
    setAllergen () {
      // アレルゲンのチェックが入っている項目を格納する
      this.allergenChecks = this.allergenchecked ? this.allergenchecked.split(',').map(Number) : []
    },
    // アレルゲンのチェックをセットする
    reinsertAllergen (value) {
      // アレルゲンのチェックが入っている項目を格納する
      let allergenChecks = value ? value.split(',').map(Number) : []
      // 重複しているアレルゲンのチェックを削除
      this.allergenChecks = allergenChecks.filter(function (x, i, self) {
        return self.indexOf(x) === i
      })
    },
    // アレルゲンのチェックを雛形の状態に戻す
    setDefaultAllergen (data) {
      this.allergenChecks = data ? data.split(',').map(Number) : []
    }
  }
}
</script>

<!-- style読み込み -->
<style lang="scss" scoped>
  @import '@/assets/scss/common/foodData.scss';
</style>
